import {FlexiPointsExpiry, QueryFlexiPointsExpiryListArgs, QueryWalletArgs, Wallet} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"
import walletQuery from "../graph/query/wallet"
import flexiPointsExpiryList, {flexiPointsExpiryListKey} from "../services/queries/flexiPointsExpiryList"

export const useWalletQuery = createUseQuery<Wallet, QueryWalletArgs>(walletQuery, {
  key: "wallet"
})

export const useFlexiPointsExpiryQuery = createUseQuery<FlexiPointsExpiry, QueryFlexiPointsExpiryListArgs>(flexiPointsExpiryList, {
  key: flexiPointsExpiryListKey
})
